import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionEditComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import styled from '@xstyled/styled-components';
import { getSize, getColor, AppModal } from '@lib/common';
import { useMemo, useCallback, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { RequestStatus } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswersSection = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledAnswersTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n"])), getSize('typo16'));
var StyledAnswersList = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding12'));
var StyledAddButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 48px;\n  border: 2px dashed #cbd5e1 !important;\n  border-radius: ", " !important;\n  background-color: transparent !important;\n  color: #475569 !important;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n\n  &:hover {\n    border-color: ", " !important;\n    color: ", " !important;\n    background-color: #f8fafc !important;\n  }\n\n  .anticon {\n    font-size: ", ";\n  }\n"])), getSize('radiusS'), getSize('padding8'), getColor('fillIntActive'), getColor('fillIntActive'), getSize('typo16'));
export var MultipleChoiceEditComponent = function MultipleChoiceEditComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var _onUpdateAnswer = actions.onUpdateAnswer,
      _onUpdateCorrectAnswer = actions.onUpdateCorrectAnswer,
      onDeleteAnswer = actions.onDeleteAnswer,
      onAddAnswer = actions.onAddAnswer,
      onAddAnswerImage = actions.onAddAnswerImage;
  var editorLabels = states.editorLabels,
      multipleChoiceLabel = states.multipleChoiceLabel,
      readonly = states.readonly,
      label = states.label,
      answerEditorRefs = states.answerEditorRefs,
      activeAnswerId = states.activeAnswerId,
      answerUploadFile = states.answerUploadFile,
      answerUploadStatus = states.answerUploadStatus;
  var multipleChoiceQuestion = question; // Handle answer image upload

  useEffect(function () {
    if (answerUploadStatus === RequestStatus.SUCCESS && answerUploadFile && answerUploadFile.url && activeAnswerId && answerEditorRefs !== null && answerEditorRefs !== void 0 && answerEditorRefs.current[activeAnswerId]) {
      answerEditorRefs.current[activeAnswerId].insertImageHandler(answerUploadFile.url);
    }
  }, [answerUploadStatus, answerUploadFile, activeAnswerId, answerEditorRefs]);
  var handleDeleteAnswer = useCallback(function (answerId) {
    AppModal.confirm({
      title: (label === null || label === void 0 ? void 0 : label.confirmDeleteQuestion) || 'Confirm Delete',
      content: (label === null || label === void 0 ? void 0 : label.doYouWantToContinueDoingThis) || 'Do you want to continue doing this?',
      okText: (label === null || label === void 0 ? void 0 : label.confirm) || 'Confirm',
      cancelText: (label === null || label === void 0 ? void 0 : label.cancel) || 'Cancel',
      onOk: function onOk() {
        onDeleteAnswer([answerId]);
      }
    });
  }, [onDeleteAnswer, label]);
  var answerItems = useMemo(function () {
    return multipleChoiceQuestion.answers.map(function (answer) {
      var isCorrectAnswer = multipleChoiceQuestion.correctAnswers.some(function (ca) {
        return ca.answerId === answer.id.toString();
      });
      return /*#__PURE__*/_jsx(AnswerItem, {
        answer: answer,
        isCorrectAnswer: isCorrectAnswer,
        onUpdateAnswer: function onUpdateAnswer(value) {
          return _onUpdateAnswer(answer.id.toString(), value);
        },
        onUpdateCorrectAnswer: function onUpdateCorrectAnswer() {
          return _onUpdateCorrectAnswer(answer.id.toString());
        },
        onDelete: multipleChoiceQuestion.answers.length > 1 ? function () {
          return handleDeleteAnswer(answer.id.toString());
        } : undefined,
        onAddImage: onAddAnswerImage ? function () {
          return onAddAnswerImage(answer.id.toString());
        } : undefined,
        editorRef: function editorRef(ref) {
          if (answerEditorRefs && ref) {
            answerEditorRefs.current[answer.id.toString()] = ref;
          }
        },
        readonly: readonly,
        editorLabels: editorLabels,
        multipleChoiceLabel: multipleChoiceLabel
      }, answer.id.toString());
    });
  }, [multipleChoiceQuestion.answers, multipleChoiceQuestion.correctAnswers, _onUpdateAnswer, _onUpdateCorrectAnswer, handleDeleteAnswer, onAddAnswerImage, answerEditorRefs, readonly, editorLabels, multipleChoiceLabel]);
  return /*#__PURE__*/_jsx(BaseQuestionEditComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      isValidForSave: states.isValidForSave && multipleChoiceQuestion.correctAnswers.length > 0
    }),
    actions: actions,
    children: multipleChoiceQuestion.answers.length > 0 && /*#__PURE__*/_jsxs(StyledAnswersSection, {
      children: [/*#__PURE__*/_jsx(StyledAnswersTitle, {
        children: "Answer Choices"
      }), /*#__PURE__*/_jsx(StyledAnswersList, {
        children: answerItems
      }), !readonly && /*#__PURE__*/_jsx(StyledAddButton, {
        type: "dashed",
        icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
        onClick: function onClick() {
          return onAddAnswer();
        },
        children: multipleChoiceLabel.addAnswer
      })]
    })
  });
};